var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgHexagon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 4374,
    viewBox: "0 0 1920 4374",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.142 -113.983L179.005 -114.073L178.867 -113.983L-20.0072 16.7791L-20.1199 16.8531V16.9879V278.473V278.608L-20.0072 278.682L178.867 409.431L179.005 409.521L179.142 409.431L378.017 278.682L378.129 278.608V278.473V16.9751V16.8403L378.017 16.7662L179.142 -113.983ZM-20.7479 16.3778L179.005 -114.952L378.757 16.3777V279.096L179.005 410.426L-20.7479 279.096V16.3778Z",
    fill: "url(#paint0_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M579.136 -113.983L578.999 -114.073L578.862 -113.983L379.987 16.7791L379.874 16.8531V16.9879V278.473V278.608L379.987 278.682L578.862 409.431L578.999 409.521L579.136 409.431L778.011 278.682L778.124 278.608V278.473V16.9751V16.8403L778.011 16.7662L579.136 -113.983ZM379.246 16.3778L578.999 -114.952L778.752 16.3777V279.096L578.999 410.426L379.246 279.096V16.3778Z",
    fill: "url(#paint1_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M979.142 -113.983L979.004 -114.073L978.867 -113.983L779.992 16.7791L779.88 16.8531V16.9879V278.473V278.608L779.992 278.682L978.867 409.431L979.004 409.521L979.142 409.431L1178.02 278.682L1178.13 278.608V278.473V16.9751V16.8403L1178.02 16.7662L979.142 -113.983ZM779.252 16.3778L979.004 -114.952L1178.76 16.3777V279.096L979.004 410.426L779.252 279.096V16.3778Z",
    fill: "url(#paint2_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.14 -113.983L1379 -114.073L1378.86 -113.983L1179.99 16.7791L1179.87 16.8531V16.9879V278.473V278.608L1179.99 278.682L1378.86 409.431L1379 409.521L1379.14 409.431L1578.01 278.682L1578.12 278.608V278.473V16.9751V16.8403L1578.01 16.7662L1379.14 -113.983ZM1179.25 16.3778L1379 -114.952L1578.75 16.3777V279.096L1379 410.426L1179.25 279.096V16.3778Z",
    fill: "url(#paint3_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1779.14 -113.983L1779 -114.073L1778.87 -113.983L1579.99 16.7791L1579.88 16.8531V16.9879V278.473V278.608L1579.99 278.682L1778.87 409.431L1779 409.521L1779.14 409.431L1978.01 278.682L1978.13 278.608V278.473V16.9751V16.8403L1978.01 16.7662L1779.14 -113.983ZM1579.25 16.3778L1779 -114.952L1978.76 16.3777V279.096L1779 410.426L1579.25 279.096V16.3778Z",
    fill: "url(#paint4_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M379.134 280.499L378.997 280.409L378.86 280.499L179.985 411.248L179.872 411.322V411.457V672.955V673.089L179.985 673.163L378.86 803.912L378.997 804.003L379.134 803.912L578.009 673.163L578.122 673.089V672.955V411.457V411.322L578.009 411.248L379.134 280.499ZM179.244 410.859L378.997 279.53L578.75 410.859V673.578L378.997 804.907L179.244 673.578V410.859Z",
    fill: "url(#paint5_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.8601 280.499L-20.9974 280.409L-21.1348 280.499L-220.009 411.248L-220.122 411.322V411.457V672.955V673.09L-220.009 673.164L-21.1348 803.913L-20.9974 804.003L-20.8601 803.913L178.015 673.164L178.127 673.09V672.955V411.457V411.322L178.015 411.248L-20.8601 280.499ZM-20.9877 279.524L178.755 410.847V673.565L-20.9974 804.895L-220.75 673.565V410.847L-20.9877 279.524Z",
    fill: "url(#paint6_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M779.14 280.499L779.002 280.409L778.865 280.499L579.99 411.248L579.878 411.322V411.457V672.955V673.089L579.99 673.163L778.865 803.912L779.002 804.003L779.14 803.912L978.014 673.163L978.127 673.089V672.955V411.457V411.322L978.014 411.248L779.14 280.499ZM579.25 410.859L779.002 279.53L978.755 410.859V673.578L779.002 804.907L579.25 673.578V410.859Z",
    fill: "url(#paint7_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.13 280.499L1179 280.409L1178.86 280.499L979.984 411.248L979.871 411.322V411.457V672.955V673.089L979.984 673.163L1178.86 803.912L1179 804.003L1179.13 803.912L1378.01 673.163L1378.12 673.089V672.955V411.457V411.322L1378.01 411.248L1179.13 280.499ZM979.243 410.859L1179 279.53L1378.75 410.859V673.578L1179 804.907L979.243 673.578V410.859Z",
    fill: "url(#paint8_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1579.14 280.499L1579 280.409L1578.86 280.499L1379.99 411.248L1379.88 411.322V411.457V672.955V673.089L1379.99 673.163L1578.86 803.912L1579 804.003L1579.14 803.912L1778.01 673.163L1778.13 673.089V672.955V411.457V411.322L1778.01 411.248L1579.14 280.499ZM1379.25 410.859L1579 279.53L1778.75 410.859V673.578L1579 804.907L1379.25 673.578V410.859Z",
    fill: "url(#paint9_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1979.13 280.499L1979 280.409L1978.86 280.499L1779.98 411.248L1779.87 411.322V411.457V672.955V673.089L1779.98 673.163L1978.86 803.912L1979 804.003L1979.13 803.912L2178.01 673.163L2178.12 673.089V672.955V411.457V411.322L2178.01 411.248L1979.13 280.499ZM1779.24 410.859L1979 279.53L2178.75 410.859V673.578L1979 804.907L1779.24 673.578V410.859Z",
    fill: "url(#paint10_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179.142 673.863L179.005 673.773L178.867 673.863L-20.0072 804.612L-20.1199 804.686V804.821V1066.32V1066.45L-20.0072 1066.53L178.867 1197.28L179.005 1197.37L179.142 1197.28L378.017 1066.53L378.129 1066.45V1066.32V804.821V804.686L378.017 804.612L179.142 673.863ZM-20.7479 804.224L179.005 672.894L378.757 804.224V1066.94L179.005 1198.27L-20.7479 1066.94V804.224Z",
    fill: "url(#paint11_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M579.136 673.863L578.999 673.773L578.862 673.863L379.987 804.612L379.874 804.686V804.821V1066.32V1066.45L379.987 1066.53L578.862 1197.28L578.999 1197.37L579.136 1197.28L778.011 1066.53L778.124 1066.45V1066.32V804.821V804.686L778.011 804.612L579.136 673.863ZM379.246 804.224L578.999 672.894L778.752 804.224V1066.94L578.999 1198.27L379.246 1066.94V804.224Z",
    fill: "url(#paint12_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M979.142 673.863L979.004 673.773L978.867 673.863L779.992 804.612L779.88 804.686V804.821V1066.32V1066.45L779.992 1066.53L978.867 1197.28L979.004 1197.37L979.142 1197.28L1178.02 1066.53L1178.13 1066.45V1066.32V804.821V804.686L1178.02 804.612L979.142 673.863ZM779.252 804.224L979.004 672.894L1178.76 804.224V1066.94L979.004 1198.27L779.252 1066.94V804.224Z",
    fill: "url(#paint13_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.14 673.863L1379 673.773L1378.86 673.863L1179.99 804.612L1179.87 804.686V804.821V1066.32V1066.45L1179.99 1066.53L1378.86 1197.28L1379 1197.37L1379.14 1197.28L1578.01 1066.53L1578.12 1066.45V1066.32V804.821V804.686L1578.01 804.612L1379.14 673.863ZM1179.25 804.224L1379 672.894L1578.75 804.224V1066.94L1379 1198.27L1179.25 1066.94V804.224Z",
    fill: "url(#paint14_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1779.14 673.863L1779 673.773L1778.87 673.863L1579.99 804.612L1579.88 804.686V804.821V1066.32V1066.45L1579.99 1066.53L1778.87 1197.28L1779 1197.37L1779.14 1197.28L1978.01 1066.53L1978.13 1066.45V1066.32V804.821V804.686L1978.01 804.612L1779.14 673.863ZM1579.25 804.224L1779 672.894L1978.76 804.224V1066.94L1779 1198.27L1579.25 1066.94V804.224Z",
    fill: "url(#paint15_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M379.134 1068.33L378.997 1068.24L378.86 1068.33L179.985 1199.08L179.872 1199.16V1199.29V1460.79V1460.92L179.985 1461L378.86 1591.75L378.997 1591.84L379.134 1591.75L578.009 1461L578.122 1460.92V1460.79V1199.29V1199.16L578.009 1199.08L379.134 1068.33ZM179.244 1198.69L378.997 1067.36L578.75 1198.69V1461.41L378.997 1592.74L179.244 1461.41V1198.69Z",
    fill: "url(#paint16_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.8601 1068.33L-20.9974 1068.24L-21.1348 1068.33L-220.009 1199.08L-220.122 1199.15V1199.29V1460.79V1460.92L-220.009 1461L-21.1348 1591.75L-20.9974 1591.84L-20.8601 1591.75L178.015 1461L178.127 1460.92V1460.79V1199.29V1199.15L178.015 1199.08L-20.8601 1068.33ZM-20.9876 1067.36L178.755 1198.68V1461.4L-20.9974 1592.73L-220.75 1461.4V1198.68L-20.9876 1067.36Z",
    fill: "url(#paint17_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M779.14 1068.33L779.002 1068.24L778.865 1068.33L579.99 1199.08L579.878 1199.16V1199.29V1460.79V1460.92L579.99 1461L778.865 1591.75L779.002 1591.84L779.14 1591.75L978.014 1461L978.127 1460.92V1460.79V1199.29V1199.16L978.014 1199.08L779.14 1068.33ZM579.25 1198.69L779.002 1067.36L978.755 1198.69V1461.41L779.002 1592.74L579.25 1461.41V1198.69Z",
    fill: "url(#paint18_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.13 1068.33L1179 1068.24L1178.86 1068.33L979.984 1199.08L979.871 1199.16V1199.29V1460.79V1460.92L979.984 1461L1178.86 1591.75L1179 1591.84L1179.13 1591.75L1378.01 1461L1378.12 1460.92V1460.79V1199.29V1199.16L1378.01 1199.08L1179.13 1068.33ZM979.243 1198.69L1179 1067.36L1378.75 1198.69V1461.41L1179 1592.74L979.243 1461.41V1198.69Z",
    fill: "url(#paint19_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1579.14 1068.33L1579 1068.24L1578.86 1068.33L1379.99 1199.08L1379.88 1199.16V1199.29V1460.79V1460.92L1379.99 1461L1578.86 1591.75L1579 1591.84L1579.14 1591.75L1778.01 1461L1778.13 1460.92V1460.79V1199.29V1199.16L1778.01 1199.08L1579.14 1068.33ZM1379.25 1198.69L1579 1067.36L1778.75 1198.69V1461.41L1579 1592.74L1379.25 1461.41V1198.69Z",
    fill: "url(#paint20_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1979.13 1068.33L1979 1068.24L1978.86 1068.33L1779.98 1199.08L1779.87 1199.16V1199.29V1460.79V1460.92L1779.98 1461L1978.86 1591.75L1979 1591.84L1979.13 1591.75L2178.01 1461L2178.12 1460.92V1460.79V1199.29V1199.16L2178.01 1199.08L1979.13 1068.33ZM1779.24 1198.69L1979 1067.36L2178.75 1198.69V1461.41L1979 1592.74L1779.24 1461.41V1198.69Z",
    fill: "url(#paint21_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M179.142 1458.5L179.005 1458.41L178.867 1458.5L-20.0072 1589.26L-20.1199 1589.34V1589.47V1850.95V1851.09L-20.0072 1851.16L178.867 1981.91L179.005 1982L179.142 1981.91L378.017 1851.16L378.129 1851.09V1850.95V1589.46V1589.32L378.017 1589.25L179.142 1458.5ZM-20.7479 1588.86L179.005 1457.53L378.757 1588.86V1851.58L179.005 1982.91L-20.7479 1851.58V1588.86Z",
    fill: "url(#paint22_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M579.136 1458.5L578.999 1458.41L578.862 1458.5L379.987 1589.26L379.874 1589.34V1589.47V1850.95V1851.09L379.987 1851.16L578.862 1981.91L578.999 1982L579.136 1981.91L778.011 1851.16L778.124 1851.09V1850.95V1589.46V1589.32L778.011 1589.25L579.136 1458.5ZM379.246 1588.86L578.999 1457.53L778.752 1588.86V1851.58L578.999 1982.91L379.246 1851.58V1588.86Z",
    fill: "url(#paint23_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M979.142 1458.5L979.004 1458.41L978.867 1458.5L779.992 1589.26L779.88 1589.34V1589.47V1850.95V1851.09L779.992 1851.16L978.867 1981.91L979.004 1982L979.142 1981.91L1178.02 1851.16L1178.13 1851.09V1850.95V1589.46V1589.32L1178.02 1589.25L979.142 1458.5ZM779.252 1588.86L979.004 1457.53L1178.76 1588.86V1851.58L979.004 1982.91L779.252 1851.58V1588.86Z",
    fill: "url(#paint24_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.14 1458.5L1379 1458.41L1378.86 1458.5L1179.99 1589.26L1179.87 1589.34V1589.47V1850.95V1851.09L1179.99 1851.16L1378.86 1981.91L1379 1982L1379.14 1981.91L1578.01 1851.16L1578.12 1851.09V1850.95V1589.46V1589.32L1578.01 1589.25L1379.14 1458.5ZM1179.25 1588.86L1379 1457.53L1578.75 1588.86V1851.58L1379 1982.91L1179.25 1851.58V1588.86Z",
    fill: "url(#paint25_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1779.14 1458.5L1779 1458.41L1778.87 1458.5L1579.99 1589.26L1579.88 1589.34V1589.47V1850.95V1851.09L1579.99 1851.16L1778.87 1981.91L1779 1982L1779.14 1981.91L1978.01 1851.16L1978.13 1851.09V1850.95V1589.46V1589.32L1978.01 1589.25L1779.14 1458.5ZM1579.25 1588.86L1779 1457.53L1978.76 1588.86V1851.58L1779 1982.91L1579.25 1851.58V1588.86Z",
    fill: "url(#paint26_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M379.134 1852.98L378.997 1852.89L378.86 1852.98L179.985 1983.73L179.872 1983.8V1983.94V2245.44V2245.57L179.985 2245.65L378.86 2376.39L378.997 2376.48L379.134 2376.39L578.009 2245.65L578.122 2245.57V2245.44V1983.94V1983.8L578.009 1983.73L379.134 1852.98ZM179.244 1983.34L378.997 1852.01L578.75 1983.34V2246.06L378.997 2377.39L179.244 2246.06V1983.34Z",
    fill: "url(#paint27_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.8601 1852.98L-20.9974 1852.89L-21.1348 1852.98L-220.009 1983.73L-220.122 1983.8V1983.94V2245.44V2245.57L-220.009 2245.65L-21.1348 2376.39L-20.9974 2376.48L-20.8601 2376.39L178.015 2245.65L178.127 2245.57V2245.44V1983.94V1983.8L178.015 1983.73L-20.8601 1852.98ZM-20.9877 1852.01L178.755 1983.33V2246.05L-20.9974 2377.38L-220.75 2246.05V1983.33L-20.9877 1852.01Z",
    fill: "url(#paint28_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M779.14 1852.98L779.002 1852.89L778.865 1852.98L579.99 1983.73L579.878 1983.8V1983.94V2245.44V2245.57L579.99 2245.65L778.865 2376.39L779.002 2376.48L779.14 2376.39L978.014 2245.65L978.127 2245.57V2245.44V1983.94V1983.8L978.014 1983.73L779.14 1852.98ZM579.25 1983.34L779.002 1852.01L978.755 1983.34V2246.06L779.002 2377.39L579.25 2246.06V1983.34Z",
    fill: "url(#paint29_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.13 1852.98L1179 1852.89L1178.86 1852.98L979.984 1983.73L979.871 1983.8V1983.94V2245.44V2245.57L979.984 2245.65L1178.86 2376.39L1179 2376.48L1179.13 2376.39L1378.01 2245.65L1378.12 2245.57V2245.44V1983.94V1983.8L1378.01 1983.73L1179.13 1852.98ZM979.243 1983.34L1179 1852.01L1378.75 1983.34V2246.06L1179 2377.39L979.243 2246.06V1983.34Z",
    fill: "url(#paint30_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1579.14 1852.98L1579 1852.89L1578.86 1852.98L1379.99 1983.73L1379.88 1983.8V1983.94V2245.44V2245.57L1379.99 2245.65L1578.86 2376.39L1579 2376.48L1579.14 2376.39L1778.01 2245.65L1778.13 2245.57V2245.44V1983.94V1983.8L1778.01 1983.73L1579.14 1852.98ZM1379.25 1983.34L1579 1852.01L1778.75 1983.34V2246.06L1579 2377.39L1379.25 2246.06V1983.34Z",
    fill: "url(#paint31_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1979.13 1852.98L1979 1852.89L1978.86 1852.98L1779.98 1983.73L1779.87 1983.8V1983.94V2245.44V2245.57L1779.98 2245.65L1978.86 2376.39L1979 2376.48L1979.13 2376.39L2178.01 2245.65L2178.12 2245.57V2245.44V1983.94V1983.8L2178.01 1983.73L1979.13 1852.98ZM1779.24 1983.34L1979 1852.01L2178.75 1983.34V2246.06L1979 2377.39L1779.24 2246.06V1983.34Z",
    fill: "url(#paint32_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M179.142 2246.35L179.005 2246.26L178.867 2246.35L-20.0072 2377.09L-20.1199 2377.17V2377.3V2638.8V2638.94L-20.0072 2639.01L178.867 2769.76L179.005 2769.85L179.142 2769.76L378.017 2639.01L378.129 2638.94V2638.8V2377.3V2377.17L378.017 2377.09L179.142 2246.35ZM-20.7479 2376.71L179.005 2245.38L378.757 2376.71V2639.42L179.005 2770.75L-20.7479 2639.42V2376.71Z",
    fill: "url(#paint33_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M579.136 2246.35L578.999 2246.26L578.862 2246.35L379.987 2377.09L379.874 2377.17V2377.3V2638.8V2638.94L379.987 2639.01L578.862 2769.76L578.999 2769.85L579.136 2769.76L778.011 2639.01L778.124 2638.94V2638.8V2377.3V2377.17L778.011 2377.09L579.136 2246.35ZM379.246 2376.71L578.999 2245.38L778.752 2376.71V2639.42L578.999 2770.75L379.246 2639.42V2376.71Z",
    fill: "url(#paint34_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M979.142 2246.35L979.004 2246.26L978.867 2246.35L779.992 2377.09L779.88 2377.17V2377.3V2638.8V2638.94L779.992 2639.01L978.867 2769.76L979.004 2769.85L979.142 2769.76L1178.02 2639.01L1178.13 2638.94V2638.8V2377.3V2377.17L1178.02 2377.09L979.142 2246.35ZM779.252 2376.71L979.004 2245.38L1178.76 2376.71V2639.42L979.004 2770.75L779.252 2639.42V2376.71Z",
    fill: "url(#paint35_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.14 2246.35L1379 2246.26L1378.86 2246.35L1179.99 2377.09L1179.87 2377.17V2377.3V2638.8V2638.94L1179.99 2639.01L1378.86 2769.76L1379 2769.85L1379.14 2769.76L1578.01 2639.01L1578.12 2638.94V2638.8V2377.3V2377.17L1578.01 2377.09L1379.14 2246.35ZM1179.25 2376.71L1379 2245.38L1578.75 2376.71V2639.42L1379 2770.75L1179.25 2639.42V2376.71Z",
    fill: "url(#paint36_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1779.14 2246.35L1779 2246.26L1778.87 2246.35L1579.99 2377.09L1579.88 2377.17V2377.3V2638.8V2638.94L1579.99 2639.01L1778.87 2769.76L1779 2769.85L1779.14 2769.76L1978.01 2639.01L1978.13 2638.94V2638.8V2377.3V2377.17L1978.01 2377.09L1779.14 2246.35ZM1579.25 2376.71L1779 2245.38L1978.76 2376.71V2639.42L1779 2770.75L1579.25 2639.42V2376.71Z",
    fill: "url(#paint37_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M379.134 2640.81L378.997 2640.72L378.86 2640.81L179.985 2771.56L179.872 2771.64V2771.77V3033.27V3033.4L179.985 3033.48L378.86 3164.23L378.997 3164.32L379.134 3164.23L578.009 3033.48L578.122 3033.4V3033.27V2771.77V2771.64L578.009 2771.56L379.134 2640.81ZM179.244 2771.17L378.997 2639.85L578.75 2771.17V3033.89L378.997 3165.22L179.244 3033.89V2771.17Z",
    fill: "url(#paint38_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.8601 2640.81L-20.9974 2640.72L-21.1348 2640.81L-220.009 2771.56L-220.122 2771.64V2771.77V3033.27V3033.4L-220.009 3033.48L-21.1348 3164.23L-20.9974 3164.32L-20.8601 3164.23L178.015 3033.48L178.127 3033.4V3033.27V2771.77V2771.64L178.015 2771.56L-20.8601 2640.81ZM-20.9876 2639.84L178.755 2771.16V3033.88L-20.9974 3165.21L-220.75 3033.88V2771.16L-20.9876 2639.84Z",
    fill: "url(#paint39_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M779.14 2640.81L779.002 2640.72L778.865 2640.81L579.99 2771.56L579.878 2771.64V2771.77V3033.27V3033.4L579.99 3033.48L778.865 3164.23L779.002 3164.32L779.14 3164.23L978.014 3033.48L978.127 3033.4V3033.27V2771.77V2771.64L978.014 2771.56L779.14 2640.81ZM579.25 2771.17L779.002 2639.85L978.755 2771.17V3033.89L779.002 3165.22L579.25 3033.89V2771.17Z",
    fill: "url(#paint40_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.13 2640.81L1179 2640.72L1178.86 2640.81L979.984 2771.56L979.871 2771.64V2771.77V3033.27V3033.4L979.984 3033.48L1178.86 3164.23L1179 3164.32L1179.13 3164.23L1378.01 3033.48L1378.12 3033.4V3033.27V2771.77V2771.64L1378.01 2771.56L1179.13 2640.81ZM979.243 2771.17L1179 2639.85L1378.75 2771.17V3033.89L1179 3165.22L979.243 3033.89V2771.17Z",
    fill: "url(#paint41_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1579.14 2640.81L1579 2640.72L1578.86 2640.81L1379.99 2771.56L1379.88 2771.64V2771.77V3033.27V3033.4L1379.99 3033.48L1578.86 3164.23L1579 3164.32L1579.14 3164.23L1778.01 3033.48L1778.13 3033.4V3033.27V2771.77V2771.64L1778.01 2771.56L1579.14 2640.81ZM1379.25 2771.17L1579 2639.85L1778.75 2771.17V3033.89L1579 3165.22L1379.25 3033.89V2771.17Z",
    fill: "url(#paint42_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1979.13 2640.81L1979 2640.72L1978.86 2640.81L1779.98 2771.56L1779.87 2771.64V2771.77V3033.27V3033.4L1779.98 3033.48L1978.86 3164.23L1979 3164.32L1979.13 3164.23L2178.01 3033.48L2178.12 3033.4V3033.27V2771.77V2771.64L2178.01 2771.56L1979.13 2640.81ZM1779.24 2771.17L1979 2639.85L2178.75 2771.17V3033.89L1979 3165.22L1779.24 3033.89V2771.17Z",
    fill: "url(#paint43_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M179.142 3031.82L179.005 3031.73L178.867 3031.82L-20.0072 3162.59L-20.1199 3162.66V3162.8V3424.28V3424.42L-20.0072 3424.49L178.867 3555.24L179.005 3555.33L179.142 3555.24L378.017 3424.49L378.129 3424.42V3424.28V3162.78V3162.65L378.017 3162.57L179.142 3031.82ZM-20.7479 3162.19L179.005 3030.86L378.757 3162.19V3424.9L179.005 3556.23L-20.7479 3424.9V3162.19Z",
    fill: "url(#paint44_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M579.136 3031.82L578.999 3031.73L578.862 3031.82L379.987 3162.59L379.874 3162.66V3162.8V3424.28V3424.42L379.987 3424.49L578.862 3555.24L578.999 3555.33L579.136 3555.24L778.011 3424.49L778.124 3424.42V3424.28V3162.78V3162.65L778.011 3162.57L579.136 3031.82ZM379.246 3162.19L578.999 3030.86L778.752 3162.19V3424.9L578.999 3556.23L379.246 3424.9V3162.19Z",
    fill: "url(#paint45_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M979.142 3031.82L979.004 3031.73L978.867 3031.82L779.992 3162.59L779.88 3162.66V3162.8V3424.28V3424.42L779.992 3424.49L978.867 3555.24L979.004 3555.33L979.142 3555.24L1178.02 3424.49L1178.13 3424.42V3424.28V3162.78V3162.65L1178.02 3162.57L979.142 3031.82ZM779.252 3162.19L979.004 3030.86L1178.76 3162.19V3424.9L979.004 3556.23L779.252 3424.9V3162.19Z",
    fill: "url(#paint46_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.14 3031.82L1379 3031.73L1378.86 3031.82L1179.99 3162.59L1179.87 3162.66V3162.8V3424.28V3424.42L1179.99 3424.49L1378.86 3555.24L1379 3555.33L1379.14 3555.24L1578.01 3424.49L1578.12 3424.42V3424.28V3162.78V3162.65L1578.01 3162.57L1379.14 3031.82ZM1179.25 3162.19L1379 3030.86L1578.75 3162.19V3424.9L1379 3556.23L1179.25 3424.9V3162.19Z",
    fill: "url(#paint47_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1779.14 3031.82L1779 3031.73L1778.87 3031.82L1579.99 3162.59L1579.88 3162.66V3162.8V3424.28V3424.42L1579.99 3424.49L1778.87 3555.24L1779 3555.33L1779.14 3555.24L1978.01 3424.49L1978.13 3424.42V3424.28V3162.78V3162.65L1978.01 3162.57L1779.14 3031.82ZM1579.25 3162.19L1779 3030.86L1978.76 3162.19V3424.9L1779 3556.23L1579.25 3424.9V3162.19Z",
    fill: "url(#paint48_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M379.134 3426.31L378.997 3426.22L378.86 3426.31L179.985 3557.06L179.872 3557.13V3557.26V3818.76V3818.9L179.985 3818.97L378.86 3949.72L378.997 3949.81L379.134 3949.72L578.009 3818.97L578.122 3818.9V3818.76V3557.26V3557.13L578.009 3557.06L379.134 3426.31ZM179.244 3556.67L378.997 3425.34L578.75 3556.67V3819.38L378.997 3950.71L179.244 3819.38V3556.67Z",
    fill: "url(#paint49_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.8601 3426.31L-20.9974 3426.22L-21.1348 3426.31L-220.009 3557.06L-220.122 3557.13V3557.26V3818.76V3818.9L-220.009 3818.97L-21.1348 3949.72L-20.9974 3949.81L-20.8601 3949.72L178.015 3818.97L178.127 3818.9V3818.76V3557.26V3557.13L178.015 3557.06L-20.8601 3426.31ZM-20.9877 3425.33L178.755 3556.65V3819.37L-20.9974 3950.7L-220.75 3819.37V3556.65L-20.9877 3425.33Z",
    fill: "url(#paint50_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M779.14 3426.31L779.002 3426.22L778.865 3426.31L579.99 3557.06L579.878 3557.13V3557.26V3818.76V3818.9L579.99 3818.97L778.865 3949.72L779.002 3949.81L779.14 3949.72L978.014 3818.97L978.127 3818.9V3818.76V3557.26V3557.13L978.014 3557.06L779.14 3426.31ZM579.25 3556.67L779.002 3425.34L978.755 3556.67V3819.38L779.002 3950.71L579.25 3819.38V3556.67Z",
    fill: "url(#paint51_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.13 3426.31L1179 3426.22L1178.86 3426.31L979.984 3557.06L979.871 3557.13V3557.26V3818.76V3818.9L979.984 3818.97L1178.86 3949.72L1179 3949.81L1179.13 3949.72L1378.01 3818.97L1378.12 3818.9V3818.76V3557.26V3557.13L1378.01 3557.06L1179.13 3426.31ZM979.243 3556.67L1179 3425.34L1378.75 3556.67V3819.38L1179 3950.71L979.243 3819.38V3556.67Z",
    fill: "url(#paint52_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1579.14 3426.31L1579 3426.22L1578.86 3426.31L1379.99 3557.06L1379.88 3557.13V3557.26V3818.76V3818.9L1379.99 3818.97L1578.86 3949.72L1579 3949.81L1579.14 3949.72L1778.01 3818.97L1778.13 3818.9V3818.76V3557.26V3557.13L1778.01 3557.06L1579.14 3426.31ZM1379.25 3556.67L1579 3425.34L1778.75 3556.67V3819.38L1579 3950.71L1379.25 3819.38V3556.67Z",
    fill: "url(#paint53_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1979.13 3426.31L1979 3426.22L1978.86 3426.31L1779.98 3557.06L1779.87 3557.13V3557.26V3818.76V3818.9L1779.98 3818.97L1978.86 3949.72L1979 3949.81L1979.13 3949.72L2178.01 3818.97L2178.12 3818.9V3818.76V3557.26V3557.13L2178.01 3557.06L1979.13 3426.31ZM1779.24 3556.67L1979 3425.34L2178.75 3556.67V3819.38L1979 3950.71L1779.24 3819.38V3556.67Z",
    fill: "url(#paint54_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M179.142 3819.67L179.005 3819.58L178.867 3819.67L-20.0072 3950.42L-20.1199 3950.49V3950.63V4212.13V4212.26L-20.0072 4212.34L178.867 4343.08L179.005 4343.17L179.142 4343.08L378.017 4212.34L378.129 4212.26V4212.13V3950.63V3950.49L378.017 3950.42L179.142 3819.67ZM-20.7479 3950.03L179.005 3818.7L378.757 3950.03V4212.75L179.005 4344.08L-20.7479 4212.75V3950.03Z",
    fill: "url(#paint55_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M579.136 3819.67L578.999 3819.58L578.862 3819.67L379.987 3950.42L379.874 3950.49V3950.63V4212.13V4212.26L379.987 4212.34L578.862 4343.08L578.999 4343.17L579.136 4343.08L778.011 4212.34L778.124 4212.26V4212.13V3950.63V3950.49L778.011 3950.42L579.136 3819.67ZM379.246 3950.03L578.999 3818.7L778.752 3950.03V4212.75L578.999 4344.08L379.246 4212.75V3950.03Z",
    fill: "url(#paint56_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M979.142 3819.67L979.004 3819.58L978.867 3819.67L779.992 3950.42L779.88 3950.49V3950.63V4212.13V4212.26L779.992 4212.34L978.867 4343.08L979.004 4343.17L979.142 4343.08L1178.02 4212.34L1178.13 4212.26V4212.13V3950.63V3950.49L1178.02 3950.42L979.142 3819.67ZM779.252 3950.03L979.004 3818.7L1178.76 3950.03V4212.75L979.004 4344.08L779.252 4212.75V3950.03Z",
    fill: "url(#paint57_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.14 3819.67L1379 3819.58L1378.86 3819.67L1179.99 3950.42L1179.87 3950.49V3950.63V4212.13V4212.26L1179.99 4212.34L1378.86 4343.08L1379 4343.17L1379.14 4343.08L1578.01 4212.34L1578.12 4212.26V4212.13V3950.63V3950.49L1578.01 3950.42L1379.14 3819.67ZM1179.25 3950.03L1379 3818.7L1578.75 3950.03V4212.75L1379 4344.08L1179.25 4212.75V3950.03Z",
    fill: "url(#paint58_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1779.14 3819.67L1779 3819.58L1778.87 3819.67L1579.99 3950.42L1579.88 3950.49V3950.63V4212.13V4212.26L1579.99 4212.34L1778.87 4343.08L1779 4343.17L1779.14 4343.08L1978.01 4212.34L1978.13 4212.26V4212.13V3950.63V3950.49L1978.01 3950.42L1779.14 3819.67ZM1579.25 3950.03L1779 3818.7L1978.76 3950.03V4212.75L1779 4344.08L1579.25 4212.75V3950.03Z",
    fill: "url(#paint59_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M379.134 4214.14L378.997 4214.05L378.86 4214.14L179.985 4344.89L179.872 4344.96V4345.1V4606.6V4606.73L179.985 4606.8L378.86 4737.55L378.997 4737.64L379.134 4737.55L578.009 4606.8L578.122 4606.73V4606.6V4345.1V4344.96L578.009 4344.89L379.134 4214.14ZM179.244 4344.5L378.997 4213.17L578.75 4344.5V4607.22L378.997 4738.55L179.244 4607.22V4344.5Z",
    fill: "url(#paint60_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.8601 4214.14L-20.9974 4214.05L-21.1348 4214.14L-220.009 4344.89L-220.122 4344.96V4345.1V4606.6V4606.73L-220.009 4606.8L-21.1348 4737.55L-20.9974 4737.64L-20.8601 4737.55L178.015 4606.8L178.127 4606.73V4606.6V4345.1V4344.96L178.015 4344.89L-20.8601 4214.14ZM-20.9876 4213.16L178.755 4344.49V4607.21L-20.9974 4738.53L-220.75 4607.21V4344.49L-20.9876 4213.16Z",
    fill: "url(#paint61_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M779.14 4214.14L779.002 4214.05L778.865 4214.14L579.99 4344.89L579.878 4344.96V4345.1V4606.6V4606.73L579.99 4606.8L778.865 4737.55L779.002 4737.64L779.14 4737.55L978.014 4606.8L978.127 4606.73V4606.6V4345.1V4344.96L978.014 4344.89L779.14 4214.14ZM579.25 4344.5L779.002 4213.17L978.755 4344.5V4607.22L779.002 4738.55L579.25 4607.22V4344.5Z",
    fill: "url(#paint62_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.13 4214.14L1179 4214.05L1178.86 4214.14L979.984 4344.89L979.871 4344.96V4345.1V4606.6V4606.73L979.984 4606.8L1178.86 4737.55L1179 4737.64L1179.13 4737.55L1378.01 4606.8L1378.12 4606.73V4606.6V4345.1V4344.96L1378.01 4344.89L1179.13 4214.14ZM979.243 4344.5L1179 4213.17L1378.75 4344.5V4607.22L1179 4738.55L979.243 4607.22V4344.5Z",
    fill: "url(#paint63_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1579.14 4214.14L1579 4214.05L1578.86 4214.14L1379.99 4344.89L1379.88 4344.96V4345.1V4606.6V4606.73L1379.99 4606.8L1578.86 4737.55L1579 4737.64L1579.14 4737.55L1778.01 4606.8L1778.13 4606.73V4606.6V4345.1V4344.96L1778.01 4344.89L1579.14 4214.14ZM1379.25 4344.5L1579 4213.17L1778.75 4344.5V4607.22L1579 4738.55L1379.25 4607.22V4344.5Z",
    fill: "url(#paint64_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1979.13 4214.14L1979 4214.05L1978.86 4214.14L1779.98 4344.89L1779.87 4344.96V4345.1V4606.6V4606.73L1779.98 4606.8L1978.86 4737.55L1979 4737.64L1979.13 4737.55L2178.01 4606.8L2178.12 4606.73V4606.6V4345.1V4344.96L2178.01 4344.89L1979.13 4214.14ZM1779.24 4344.5L1979 4213.17L2178.75 4344.5V4607.22L1979 4738.55L1779.24 4607.22V4344.5Z",
    fill: "url(#paint65_linear_8507_50754)",
    stroke: "#F9F9F9",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8507_50754",
    x1: 179.005,
    y1: -115.251,
    x2: 179.005,
    y2: 248.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8507_50754",
    x1: 578.999,
    y1: -115.251,
    x2: 578.999,
    y2: 248.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8507_50754",
    x1: 979.004,
    y1: -115.251,
    x2: 979.004,
    y2: 248.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8507_50754",
    x1: 1379,
    y1: -115.251,
    x2: 1379,
    y2: 248.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8507_50754",
    x1: 1779,
    y1: -115.251,
    x2: 1779,
    y2: 248.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8507_50754",
    x1: 378.997,
    y1: 279.231,
    x2: 378.997,
    y2: 642.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8507_50754",
    x1: -20.9974,
    y1: 279.218,
    x2: -20.9974,
    y2: 642.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8507_50754",
    x1: 779.002,
    y1: 279.231,
    x2: 779.002,
    y2: 642.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8507_50754",
    x1: 1179,
    y1: 279.231,
    x2: 1179,
    y2: 642.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8507_50754",
    x1: 1579,
    y1: 279.231,
    x2: 1579,
    y2: 642.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8507_50754",
    x1: 1979,
    y1: 279.231,
    x2: 1979,
    y2: 642.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8507_50754",
    x1: 179.005,
    y1: 672.595,
    x2: 179.005,
    y2: 1036.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8507_50754",
    x1: 578.999,
    y1: 672.595,
    x2: 578.999,
    y2: 1036.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8507_50754",
    x1: 979.004,
    y1: 672.595,
    x2: 979.004,
    y2: 1036.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8507_50754",
    x1: 1379,
    y1: 672.595,
    x2: 1379,
    y2: 1036.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_8507_50754",
    x1: 1779,
    y1: 672.595,
    x2: 1779,
    y2: 1036.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_8507_50754",
    x1: 378.997,
    y1: 1067.06,
    x2: 378.997,
    y2: 1430.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_8507_50754",
    x1: -20.9974,
    y1: 1067.05,
    x2: -20.9974,
    y2: 1430.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_8507_50754",
    x1: 779.002,
    y1: 1067.06,
    x2: 779.002,
    y2: 1430.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_8507_50754",
    x1: 1179,
    y1: 1067.06,
    x2: 1179,
    y2: 1430.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_8507_50754",
    x1: 1579,
    y1: 1067.06,
    x2: 1579,
    y2: 1430.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_8507_50754",
    x1: 1979,
    y1: 1067.06,
    x2: 1979,
    y2: 1430.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_8507_50754",
    x1: 179.005,
    y1: 1457.23,
    x2: 179.005,
    y2: 1820.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_8507_50754",
    x1: 578.999,
    y1: 1457.23,
    x2: 578.999,
    y2: 1820.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_8507_50754",
    x1: 979.004,
    y1: 1457.23,
    x2: 979.004,
    y2: 1820.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_8507_50754",
    x1: 1379,
    y1: 1457.23,
    x2: 1379,
    y2: 1820.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_8507_50754",
    x1: 1779,
    y1: 1457.23,
    x2: 1779,
    y2: 1820.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_8507_50754",
    x1: 378.997,
    y1: 1851.71,
    x2: 378.997,
    y2: 2215.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_8507_50754",
    x1: -20.9974,
    y1: 1851.7,
    x2: -20.9974,
    y2: 2215.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_8507_50754",
    x1: 779.002,
    y1: 1851.71,
    x2: 779.002,
    y2: 2215.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_8507_50754",
    x1: 1179,
    y1: 1851.71,
    x2: 1179,
    y2: 2215.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_8507_50754",
    x1: 1579,
    y1: 1851.71,
    x2: 1579,
    y2: 2215.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_8507_50754",
    x1: 1979,
    y1: 1851.71,
    x2: 1979,
    y2: 2215.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_8507_50754",
    x1: 179.005,
    y1: 2245.08,
    x2: 179.005,
    y2: 2608.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_8507_50754",
    x1: 578.999,
    y1: 2245.08,
    x2: 578.999,
    y2: 2608.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_8507_50754",
    x1: 979.004,
    y1: 2245.08,
    x2: 979.004,
    y2: 2608.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_8507_50754",
    x1: 1379,
    y1: 2245.08,
    x2: 1379,
    y2: 2608.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_8507_50754",
    x1: 1779,
    y1: 2245.08,
    x2: 1779,
    y2: 2608.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_8507_50754",
    x1: 378.997,
    y1: 2639.55,
    x2: 378.997,
    y2: 3003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_8507_50754",
    x1: -20.9974,
    y1: 2639.53,
    x2: -20.9974,
    y2: 3002.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_8507_50754",
    x1: 779.002,
    y1: 2639.55,
    x2: 779.002,
    y2: 3003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_8507_50754",
    x1: 1179,
    y1: 2639.55,
    x2: 1179,
    y2: 3003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_8507_50754",
    x1: 1579,
    y1: 2639.55,
    x2: 1579,
    y2: 3003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_8507_50754",
    x1: 1979,
    y1: 2639.55,
    x2: 1979,
    y2: 3003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_8507_50754",
    x1: 179.005,
    y1: 3030.56,
    x2: 179.005,
    y2: 3394.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_8507_50754",
    x1: 578.999,
    y1: 3030.56,
    x2: 578.999,
    y2: 3394.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_8507_50754",
    x1: 979.004,
    y1: 3030.56,
    x2: 979.004,
    y2: 3394.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_8507_50754",
    x1: 1379,
    y1: 3030.56,
    x2: 1379,
    y2: 3394.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_8507_50754",
    x1: 1779,
    y1: 3030.56,
    x2: 1779,
    y2: 3394.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_8507_50754",
    x1: 378.997,
    y1: 3425.04,
    x2: 378.997,
    y2: 3788.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_8507_50754",
    x1: -20.9974,
    y1: 3425.03,
    x2: -20.9974,
    y2: 3788.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_8507_50754",
    x1: 779.002,
    y1: 3425.04,
    x2: 779.002,
    y2: 3788.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_8507_50754",
    x1: 1179,
    y1: 3425.04,
    x2: 1179,
    y2: 3788.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_8507_50754",
    x1: 1579,
    y1: 3425.04,
    x2: 1579,
    y2: 3788.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_8507_50754",
    x1: 1979,
    y1: 3425.04,
    x2: 1979,
    y2: 3788.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_8507_50754",
    x1: 179.005,
    y1: 3818.4,
    x2: 179.005,
    y2: 4181.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_8507_50754",
    x1: 578.999,
    y1: 3818.4,
    x2: 578.999,
    y2: 4181.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_8507_50754",
    x1: 979.004,
    y1: 3818.4,
    x2: 979.004,
    y2: 4181.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_8507_50754",
    x1: 1379,
    y1: 3818.4,
    x2: 1379,
    y2: 4181.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_8507_50754",
    x1: 1779,
    y1: 3818.4,
    x2: 1779,
    y2: 4181.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_8507_50754",
    x1: 378.997,
    y1: 4212.87,
    x2: 378.997,
    y2: 4576.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_8507_50754",
    x1: -20.9974,
    y1: 4212.86,
    x2: -20.9974,
    y2: 4576.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_8507_50754",
    x1: 779.002,
    y1: 4212.87,
    x2: 779.002,
    y2: 4576.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_8507_50754",
    x1: 1179,
    y1: 4212.87,
    x2: 1179,
    y2: 4576.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_8507_50754",
    x1: 1579,
    y1: 4212.87,
    x2: 1579,
    y2: 4576.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_8507_50754",
    x1: 1979,
    y1: 4212.87,
    x2: 1979,
    y2: 4576.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHexagon);
export default __webpack_public_path__ + "static/media/bg-hexagon.d9fa3859f89699bdc1b01a87959b3efb.svg";
export { ForwardRef as ReactComponent };